import { Device } from 'app/modules/system-settings/devices/core/type';
import { TabletFilterDetail, User } from 'app/modules/system-settings/users/core/type';

export enum STATUS_USER {
  ACTIVATE = 1,
  DEACTIVATE = 2,
}

export const DEFAULT_TABLET_FILTER: TabletFilterDetail = {
  deviceId: [],
  userId: [],
  startTime: null,
  endTime: null,
  page: 1,
};

export const TABLET_OPTIONS = (tablets: Device[] | undefined) =>
  tablets?.map((el) => ({
    ...el,
    label: el.name,
    value: String(el.id),
  }));

export const USER_OPTIONS = (users: User[] | undefined) =>
  users?.map((el) => ({
    ...el,
    label: el.username,
    value: String(el.id),
  }));

export const SELECTED_TABLET = (tabletIds: string[], tablets: Device[] | undefined) =>
  tabletIds.map((el) => {
    const tablet = tablets?.find((t) => String(t.id) === el);

    return {
      value: el,
      label: tablet ? tablet.name : '',
    };
  });

export const SELECTED_USER = (userIds: string[], users: User[] | undefined) =>
  userIds.map((el) => {
    const user = users?.find((u) => String(u.id) === el);

    return {
      value: el,
      label: user ? user.username : '',
    };
  });

export const INPUT_DATE_FILTER_RANGES = (from_date: string | null, to_date: string | null) => [
  {
    key: 'selection',
    startDate: from_date ? new Date(from_date) : new Date(),
    endDate: to_date ? new Date(to_date) : new Date(),
  },
];
